import { createContext, useContext, useState } from 'react';

const GoalCompletionContext = createContext();

export function GoalCompletionProvider({ children }) {
  const [completedGoal, setCompletedGoal] = useState(null);

  return (
    <GoalCompletionContext.Provider value={{ completedGoal, setCompletedGoal }}>
      {children}
    </GoalCompletionContext.Provider>
  );
}

export function useGoalCompletion() {
  const context = useContext(GoalCompletionContext);
  if (!context) {
    throw new Error('useGoalCompletion must be used within GoalCompletionProvider');
  }
  return context;
}